import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { toast } from "sonner";

export default function OAuthProviderCallback({ provider }) {
  const loc = useLocation();
  const nav = useNavigate();
  const [msg, setMsg] = useState("Finalizing connection…");
  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const code = params.get("code");
    const state = params.get("state");
    if (!code || !state) { setMsg("Missing OAuth response."); return; }
    const replayKey = `oauth_cb_processed:${provider}:${state}`;
    try {
      const existing = window.sessionStorage.getItem(replayKey);
      if (existing === "in-flight" || existing === "done") {
        nav("/dashboard", { replace: true });
        return;
      }
      window.sessionStorage.setItem(replayKey, "in-flight");
    } catch {
      // Continue without a lock if storage is unavailable.
    }
    const redirect_uri = window.location.origin + loc.pathname;
    (async () => {
      try {
        const path = provider === "gmail" ? "/oauth/google/callback" : "/oauth/microsoft/callback";
        const { data } = await api.post(path, { code, state, redirect_uri });
        try {
          window.sessionStorage.setItem(replayKey, "done");
        } catch {}
        toast.success(`${provider === "gmail" ? "Gmail" : "Outlook"} connected: ${data.email}`);
        nav("/dashboard", { replace: true });
      } catch (e) {
        try {
          window.sessionStorage.setItem(replayKey, "done");
        } catch {}
        const raw = `${e?.response?.data?.detail || e?.message || "Unknown error"}`;
        const lower = raw.toLowerCase();
        let friendly = raw;
        if (provider !== "gmail") {
          if (lower.includes("aadsts65001") || lower.includes("consent")) {
            friendly = "Your organization blocks user consent. Ask your Microsoft 365 admin to use 'Approve Outlook for organization' on Dashboard, then try again.";
          } else if (lower.includes("aadsts50011") || lower.includes("redirect_uri")) {
            friendly = "Microsoft redirect URI mismatch. Ensure your Entra app has the exact callback URL configured.";
          } else if (lower.includes("aadsts700016")) {
            friendly = "Microsoft app ID not found for this tenant. Check MS_CLIENT_ID and tenant settings in backend env.";
          }
        }
        toast.error(`Failed to connect ${provider}: ${friendly}`);
        nav("/dashboard", { replace: true });
      }
    })();
  }, [loc, nav, provider]);
  return <div className="min-h-screen flex items-center justify-center font-mono text-sm">{msg}</div>;
}
